export const FOOTER_ELEMENT_ID = 'footer-editor';
export const QRCODE_ELEMENT_ID = 'qr-code-link';
export const FOOTER_ELEMENT_SELECTOR = `#${FOOTER_ELEMENT_ID}`;
export const QRCODE_ELEMENT_SELECTOR = `#${QRCODE_ELEMENT_ID}`;
